export const CHANGELOGS_QUERY_KEYS = {
  all: ["changelogs"] as const,
  lists: () => [...CHANGELOGS_QUERY_KEYS.all, "list"] as const,
  list: (page: number) => [...CHANGELOGS_QUERY_KEYS.lists(), page] as const,
  infinite: () => [...CHANGELOGS_QUERY_KEYS.all, "infinite"] as const,
  detail: (id: string) => [...CHANGELOGS_QUERY_KEYS.all, "detail", id] as const,
  latestPopup: () => [...CHANGELOGS_QUERY_KEYS.all, "latest-popup"] as const,
} as const;
